import comp from "./TruncatedTextWithTooltip";
export default comp;
